import React, { useState, useRef, useEffect } from 'react'
import { Switch, message, Button, Progress, Icon, Modal, Input, Tooltip, Checkbox } from 'antd'
import { Link } from 'react-router-dom'
import { createRule, updateRule, updateStatusRule } from '../../../../services/api/3dApi'
import getHistory from '../../../../helpers/rounting/getHistory'
import _ from 'lodash'

function RuleCreateBatchRow(props) {
    const { item = {}, setType, setPage, updateSelectedItems, selectedItems = [], reset } = { ...props }
    const {
        partner,
        priority,
        products,
        required_tags,
        stores,
        // schedule,
        only_package,
        only_store,
        batch_info,
        quantity,
        condition = [],
        is_fit = false,
        // split_by_pack = false,
        // variants = [],
        // fit_condition,
        catalog = {},
        schedules = []
    } = { ...item }
    const Quantity = quantity || {}
    const onlyPackage = only_package
    const onlyStore = only_store
    // const userCreate = batch_info.user_create
    // const batchPartner = batch_info.partner
    // const batchQuantity = batch_info.limit_quantity
    const {
        quantity: conditionQty,
        batch_info: conditionBatchInfo,
    } = { ...condition }

    const [status, setStatus] = useState(item.is_active || false)
    const [loadingStatus, setLoadingStatus] = useState(false)
    const [hoverRule, setHoverRule] = useState()
    const [hoverCondition, setHoverCondition] = useState()
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [priorityClone, setPriorityClone] = useState('')
    const [validate, setValidate] = useState({})
    const [errors, setErrors] = useState('')
    const [showAllRole, setShowAllRole] = useState(false)
    const [showAllCatalog, setShowAllCatalog] = useState(false)
    const [showAllTag, setShowAllTag] = useState(false)
    const [showAllStore, setShowAllStore] = useState(false)
    const [showAllSizeOfMaterials, setShowAllSizeOfMaterials] = useState(false)
    const [showAllVariant, setShowAllVariant] = useState(false)

    useEffect(() => {
        setStatus(item.is_active)
    }, [item.is_active])

    const showallonclick = (type) => {
        if (type === 'SKU') setShowAllRole(!showAllRole)
        if (type === 'Tag') setShowAllTag(!showAllTag)
        if (type === 'Store') setShowAllStore(!showAllStore)
        if (type === 'SizeOfMaterials') setShowAllSizeOfMaterials(!showAllSizeOfMaterials)
        if (type === 'Variant') setShowAllVariant(!showAllVariant)
        if (type === 'Catalog') setShowAllCatalog(!showAllCatalog)
    }

    const refSKU = useRef()
    const refCatalog = useRef()
    const refTag = useRef()
    const refStore = useRef()
    const refSizeOfMaterials = useRef()
    const refVariant = useRef()

    const getPartner = (partner) => {
        const { code, name } = partner
        if (name) {
            if (code) {
                return `${name} (${code})`
            }
            return name
        }
        return '-'
    }

    const getTag = (Tag) => {
        const { mode, tags = [] } = { ...Tag }
        if (mode === 'production') {
            return (
                !!tags && !!tags.length &&
                <label className='mb-0 text-info'>{tags.join(', ')}</label>
            )
        }
        if (mode === 'exclude') {
            return (
                <>
                    <div className={showAllTag === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                        <div ref={refTag}>
                            <label className="w-100 mb-0">All</label>
                            {
                                !!tags && !!Object.keys(tags).length &&
                                <label className="text-danger">{tags.join(', ')}</label>
                            }
                        </div>
                    </div>
                    {
                        !!refTag.current ? (
                            (refTag.current.offsetHeight > 85 && showAllTag === false) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Tag')}>More...</small>
                                </a> :
                                (refTag.current.offsetHeight > 85 && showAllTag === true) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('Tag')}>Less...</small>
                                    </a> : ""
                        ) : ""
                    }
                </>
            )
        }
        return (!!tags && !!Object.keys(tags).length &&
            <>
                <div className={showAllTag === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                    <div ref={refTag}>
                        <label className='mb-0'>{tags.join(', ')}</label>
                    </div>
                </div>
                {
                    !!refTag.current ? (
                        (refTag.current.offsetHeight > 85 && showAllTag === false) ?
                            <a className="float-right mr-3 text-primary">
                                <small className="float-right" onClick={() => showallonclick('Tag')}>More...</small>
                            </a> :
                            (refTag.current.offsetHeight > 85 && showAllTag === true) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Tag')}>Less...</small>
                                </a> : ""
                    ) : ""
                }
            </>
        )
    }

    const getSchedule = (scheduleList) => {
        if (!scheduleList.length) return '-'

        const weekdayNames = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']
        const customOrder = [1, 2, 3, 4, 5, 6, 0]

        const scheduleSort = scheduleList.sort((a, b) => {
            const startA = a.times[0]?.start || "00:00"
            const startB = b.times[0]?.start || "00:00"
            return startA.localeCompare(startB)
        })

        return scheduleSort.map(item => {
            const rawDays = item.days_of_week.map(d => d.day)
            const dayNumbers = customOrder.filter(d => rawDays.includes(d))

            const results = []
            let start = dayNumbers[0]
            let end = dayNumbers[0]

            for (let i = 1; i < dayNumbers.length; i++) {
                if (dayNumbers[i] === end + 1 || (end === 6 && dayNumbers[i] === 0)) {
                    end = dayNumbers[i]
                } else {
                    if (start === end) {
                        results.push(weekdayNames[start])
                    } else {
                        results.push(`${weekdayNames[start]} - ${weekdayNames[end]}`)
                    }
                    start = dayNumbers[i]
                    end = dayNumbers[i]
                }
            }

            if (start === end) {
                results.push(weekdayNames[start])
            } else {
                results.push(`${weekdayNames[start]} - ${weekdayNames[end]}`)
            }

            const timeStr = item.times.map(t => t.end ? `${t.start}-${t.end}` : t.start).join(', ')

            return <div>{`${results.join(', ')} | ${timeStr}`}</div>
        })
    }

    const getStore = (Store) => {
        const { mode, list = [] } = { ...Store }
        if (mode === 'exclude') {
            return (
                <>
                    <div className={showAllStore === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                        <div ref={refStore}>
                            <label className="w-100 mb-0">All</label>
                            {
                                !!list && !!Object.keys(list).length &&
                                <label className="text-danger">{list.join(', ')}</label>
                            }
                        </div>
                    </div>
                    {
                        !!refStore.current ? (
                            (refStore.current.offsetHeight > 85 && showAllStore === false) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Store')}>More...</small>
                                </a> :
                                (refStore.current.offsetHeight > 85 && showAllStore === true) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('Store')}>Less...</small>
                                    </a> : ""
                        ) : ""
                    }
                </>
            )
        }
        return (!!list && !!Object.keys(list).length &&
            <>
                <div className={showAllStore === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                    <div ref={refStore}>
                        <label className='mb-0'>{list.join(', ')}</label>
                    </div>
                </div>
                {
                    !!refStore.current ? (
                        (refStore.current.offsetHeight > 85 && showAllStore === false) ?
                            <a className="float-right mr-3 text-primary">
                                <small className="float-right" onClick={() => showallonclick('Store')}>More...</small>
                            </a> :
                            (refStore.current.offsetHeight > 85 && showAllStore === true) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Store')}>Less...</small>
                                </a> : ""
                    ) : ""
                }
            </>
        )
    }

    const getSku = (Sku) => {
        const { mode, sku = [] } = { ...Sku }
        if (mode === 'exclude') {
            return (
                <>
                    <div className={showAllRole === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                        <div ref={refSKU}>
                            <label className="w-100 mb-0">All</label>
                            {
                                !!sku && !!Object.keys(sku).length &&
                                <label className="text-danger">{sku.join(', ')}</label>
                            }
                        </div>
                    </div>
                    {
                        !!refSKU.current ? (
                            (refSKU.current.offsetHeight > 85 && showAllRole === false) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('SKU')}>More...</small>
                                </a> :
                                (refSKU.current.offsetHeight > 85 && showAllRole === true) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('SKU')}>Less...</small>
                                    </a> : ""
                        ) : ""
                    }
                </>
            )
        }
        return (
            !!sku && !!Object.keys(sku).length &&
            <>
                <div className={showAllRole === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                    <div ref={refSKU}>
                        <label className='mb-0'>{sku.join(', ')}</label>
                    </div>
                </div>
                {
                    !!refSKU.current ? (
                        (refSKU.current.offsetHeight > 85 && showAllRole === false) ?
                            <a className="float-right mr-3 text-primary">
                                <small className="float-right" onClick={() => showallonclick('SKU')}>More...</small>
                            </a> :
                            (refSKU.current.offsetHeight > 85 && showAllRole === true) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('SKU')}>Less...</small>
                                </a> : ""
                    ) : ""
                }
            </>
        )
    }

    const getCatalog = (catalog) => {
        const { mode, ids = [] } = { ...catalog }
        const catalogs = ids.map(i => i.name)
        if (mode === 'exclude') {
            return (
                <>
                    <div className={showAllCatalog === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                        <div ref={refCatalog}>
                            <label className="w-100 mb-0">All</label>
                            {
                                !!catalogs && !!Object.keys(catalogs).length &&
                                <label className="text-danger font-weight-bold">{catalogs.join(', ')}</label>
                            }
                        </div>
                    </div>
                    {
                        !!refCatalog.current ? (
                            (refCatalog.current.offsetHeight > 85 && showAllCatalog === false) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Catalog')}>More...</small>
                                </a> :
                                (refCatalog.current.offsetHeight > 85 && showAllCatalog === true) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('Catalog')}>Less...</small>
                                    </a> : ""
                        ) : ""
                    }
                </>
            )
        }
        return (
            !!catalogs && !!Object.keys(catalogs).length &&
            <>
                <div className={showAllCatalog === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                    <div ref={refCatalog}>
                        <label className='mb-0 font-weight-bold'>{catalogs.join(', ')}</label>
                    </div>
                </div>
                {
                    !!refCatalog.current ? (
                        (refCatalog.current.offsetHeight > 85 && showAllCatalog === false) ?
                            <a className="float-right mr-3 text-primary">
                                <small className="float-right" onClick={() => showallonclick('Catalog')}>More...</small>
                            </a> :
                            (refCatalog.current.offsetHeight > 85 && showAllCatalog === true) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Catalog')}>Less...</small>
                                </a> : ""
                    ) : ""
                }
            </>
        )
    }

    const handleChangeStatusRule = async () => {
        setLoadingStatus(true)

        // const newSchedules = schedules.map(scheduleItem => {
        //     const { variants = [] } = scheduleItem
        //     const newVariants = variants.map(item => ({
        //         ...item,
        //         conditions: item.conditions.map(condition => ({
        //             ...condition,
        //             partner: condition.partner._id
        //         }))
        //     }))

        //     return {
        //         ...scheduleItem,
        //         variants: newVariants
        //     }
        // })

        // const payload = {
        //     ...item,
        //     priority: priority,
        //     partner: partner._id,
        //     schedules: newSchedules,
        //     is_active: !status,
        // }

        try {
            const { data: res } = await updateStatusRule(item._id)
            const { success, error: mess, data } = { ...res }
            if (!success) throw new Error(mess)
            message.success('Update status successfully!')
            setStatus(data.is_active || false)

        } catch (e) {
            const { data: resErr } = { ...e.response }
            const { message: ErrMess } = { ...resErr }
            message.error(ErrMess || e.message)
        } finally {
            setLoadingStatus(false)
            reset()
        }
    }

    const toggleModalClone = () => {
        setPriorityClone('')
        setValidate({})
        setIsOpenModal(!isOpenModal)
    }

    const handleCloneRule = async () => {
        setErrors('')
        if (Validate()) return

        const newSchedules = schedules.map(scheduleItem => {
            const { variants = [] } = scheduleItem
            const newVariants = variants.map(item => ({
                ...item,
                conditions: item.conditions.map(condition => ({
                    ...condition,
                    partner: condition.partner._id
                }))
            }))

            return {
                ...scheduleItem,
                variants: newVariants
            }
        })

        const payload = {
            ...item,
            priority: priorityClone,
            partner: partner._id,
            schedules: newSchedules
        }

        try {
            const { data: res } = await createRule(payload)
            const { success, error: mess } = res
            if (!success) {
                throw new Error(mess)
            }
            message.success('Rule created!!!')
            const history = getHistory()
            //history.push(`/list-rule-create-batch`)
            history.push(`/edit-rule/${res.data._id}`)
            setErrors('')
        } catch (error) {
            message.error(error.message)
            setErrors(error.message)
        }
    }

    const handleChangePriority = (e) => {
        const newValidate = { ...validate }
        delete newValidate['priority']
        setValidate(newValidate)

        setPriorityClone(parseFloat(e.target.value))
    }

    const Validate = () => {
        const errorValidate = {}
        if (!priorityClone) {
            errorValidate.priority = 'Please input priority!!!'
        }

        setValidate(errorValidate)
        if (!!Object.keys(errorValidate).length) {
            return true
        }
        return false
    }

    return (
        <tr className="RowBatchRule" key={item._id}>
            <td className='selectRow' style={{ width: 40 }}>
                <Checkbox checked={selectedItems.includes(item._id)} onChange={() => updateSelectedItems(item._id, !(selectedItems.includes(item._id)))} />
            </td>
            <td className="BatchSelectedAll">
                {priority}
            </td>
            <td>
                {getPartner(partner) || '-'}
            </td>
            <td className="Sku">
                {getCatalog(catalog)}
                {getSku(products) || '-'}
            </td>
            <td className="Tags">
                {getTag(required_tags) || '-'}
            </td>
            <td className="Stores">
                {getStore(stores) || '-'}
            </td>
            <td className='ruleType'>
                {is_fit ? 'Diện tích' : 'Số lượng'}
            </td>
            <td>
                <Checkbox checked={onlyPackage} />
            </td>
            <td>
                <Checkbox checked={onlyStore} />
            </td>
            <td>{getSchedule(schedules)}</td>
            {/* <td>
                {is_fit && frames.length > 0 ?
                    <>
                        <div className={showAllSizeOfMaterials === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                            <div ref={refSizeOfMaterials}>
                                {frames.map((i, idx) => (
                                    <div key={`${item._id}_KhoNVL_${idx}`}>
                                        <Tooltip title={`${(!!i.w || i.w === 0) ? 'Width' : ''}${((!!i.w || i.w === 0) && (!!i.h || i.h === 0)) ? ' x ' : ''}${(!!i.h || i.h === 0) ? 'Height' : ''}`}>
                                            <span>
                                                {`${i.w || 0} x ${i.h || 0}`}
                                            </span>
                                        </Tooltip>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {
                            !!refSizeOfMaterials.current ? (
                                (refSizeOfMaterials.current.offsetHeight > 85 && showAllSizeOfMaterials === false) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('SizeOfMaterials')}>More...</small>
                                    </a> :
                                    (refSizeOfMaterials.current.offsetHeight > 85 && showAllSizeOfMaterials === true) ?
                                        <a className="float-right mr-3 text-primary">
                                            <small className="float-right" onClick={() => showallonclick('SizeOfMaterials')}>Less...</small>
                                        </a> : ""
                            ) : ""
                        }
                    </> : ''}
            </td> */}
            <td>
                {!is_fit && !!schedules.length ?
                    schedules.map(scheduleItem => {
                        const { variants = [] } = scheduleItem
                        return (
                            <>
                                <div className={showAllVariant === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                                    <div ref={refVariant}>
                                        {variants.map((i, idx) => (
                                            i.name !== '__ALL_SIZE__' &&
                                            <div key={`${item._id}_variant_${idx}`}>{i.name}</div>
                                        ))}
                                    </div>
                                </div>
                                {
                                    !!refVariant.current ? (
                                        (refVariant.current.offsetHeight > 85 && showAllVariant === false) ?
                                            <a className="float-right mr-3 text-primary">
                                                <small className="float-right" onClick={() => showallonclick('Variant')}>More...</small>
                                            </a> :
                                            (refVariant.current.offsetHeight > 85 && showAllVariant === true) ?
                                                <a className="float-right mr-3 text-primary">
                                                    <small className="float-right" onClick={() => showallonclick('Variant')}>Less...</small>
                                                </a> : ""
                                    ) : ""
                                }
                            </>
                        )
                    })
                    : ''}
            </td>
            <td>
                <Switch checked={status} onChange={handleChangeStatusRule} disabled={loadingStatus} />
            </td>
            <td>
                {item._id &&
                    <span className="text-primary">
                        <Link className="linkDetail" to={`/edit-rule/${item._id}`}>
                            <Button type="link" icon="edit" />
                        </Link>
                    </span>
                }

                <Tooltip title="Clone Rule">
                    <Icon
                        type="copy"
                        className="cursor-pointer"
                        onClick={toggleModalClone}
                    />
                </Tooltip>

                <Modal title="Clone Rule" visible={isOpenModal} okText="Clone" onOk={handleCloneRule} onCancel={toggleModalClone}>
                    <div className='CloneRuleContainer'>
                        <label>Priority<span style={{ color: 'red' }}> *</span></label>
                        <Input
                            type="number"
                            className={(!!validate.priority && validate.priority.length > 0) ? 'Error' : ''}
                            value={priorityClone || ''}
                            placeholder="Priority"
                            onChange={e => handleChangePriority(e)}
                        />

                        {
                            !!validate.priority && validate.priority.length > 0 &&
                            <small className="Validate" style={{ color: 'red' }}>{validate.priority}</small>
                        }
                    </div>
                </Modal>
            </td>
        </tr>
    )
}

export default RuleCreateBatchRow